"use client"

import { ResultFactory } from "@/types/generic/Result"

export const addFreeShipping = async () => {
    try {
        const response = await fetch("/api/centra/add-free-shipping", {
            method: "POST",
            headers: { "Content-Type": "application/json" }
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()

        if (!data.success) {
            throw new Error(data.error || "Failed to add free shipping")
        }
        return ResultFactory.success({ success: true, data: data.data })
    } catch (error) {
        console.error("Error adding free shipping:", error)
        throw error
    }
}

export default addFreeShipping
